<script lang="ts">
    import type {RecordHolding} from 'typings/portaro.be.types';
    import type {DocumentDetailReactivePageData, DocumentDetailStaticPageData} from '../types';
    import {getLocalization} from 'core/svelte-context/context';
    import {getPageContext} from 'shared/layouts/page-context';
    import {onDestroy} from 'svelte';
    import KpVerticalButtonsPanel from 'shared/ui-widgets/vertical-buttons-panel/KpVerticalButtonsPanel.svelte';
    import DocumentDetailEditButtons from '../components/DocumentDetailEditButtons.svelte';

    export let isSutor = false;

    const localize = getLocalization();
    const pageContext = getPageContext<DocumentDetailStaticPageData, DocumentDetailReactivePageData>();

    const model = pageContext.staticData.model;
    let recordHoldings: RecordHolding[] | undefined;
    const reactiveDataUnsubscribe = pageContext.reactiveData.subscribe((data) => recordHoldings = data.allRecordHoldings);
    onDestroy(reactiveDataUnsubscribe);
</script>

{#if model.editable || model.creatable || (model.filesManageable && !isSutor) || model.holdingDeletable || model.intoCollectionsInsertable}
    <section class="edit-panel" aria-labelledby="edit-panel-label">
        <KpVerticalButtonsPanel>
            <svelte:fragment slot="heading">
                <h2 id="edit-panel-label" class="unset-style">
                    {localize(/* @kp-localization record.RecordManagement */ 'record.RecordManagement')}
                </h2>
            </svelte:fragment>

            <DocumentDetailEditButtons {model} {recordHoldings} isSutor={false}/>
        </KpVerticalButtonsPanel>
    </section>
{/if}

<style lang="less">
    :global {
        .edit-panel .record-management-container button {
            white-space: normal;
        }
    }
</style>